import { AxiosResponse } from 'axios'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const SupplierRegistrationServices = () => {
  const path = 'Fornecedor'
  const create = async (requestObj: IFornecedor): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const getByname = async (name: string): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/Autocomplete/?nmFornecedor=${name}`)

  const getByCnpj = async (cnpj: string): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/GetByCnpj/${cnpj}`)

  const getByDescricao = async (
    descricao: string
  ): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/GetByDescricao/${descricao}`)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const getAll = async (): Promise<AxiosResponse<IFornecedor[]>> =>
    await RequestREAD.get(path)

  const get = async (id: number): Promise<AxiosResponse<IFornecedor>> =>
    await RequestREAD.get(`${path}/${id}`)

  const patch = async (requestObj: IFornecedor): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  const getFilterProps = async ({
    CdFornecedor,
    CdFornecedorSap,
    CdTipoFornecedor,
    CdDocto,
    NmFornecedor,
    PageNumber,
    PageSize
  }: IGetFilterProps): Promise<AxiosResponse<IResponseFiltroFornecedor>> =>
    await RequestREAD.get(`${path}/Filtro`, {
      params: {
        CdDocto,
        CdFornecedor,
        CdFornecedorSap,
        CdTipoFornecedor,
        NmFornecedor,
        PageNumber,
        PageSize
      }
    })

  const anexarEvidenciaSubContrato = async (
    objRequest: RequestAnexarEvidenciaSubContrato
  ): Promise<AxiosResponse> =>
    await RequestCDU.post('AnexarDocEvidenciaSubContrato', objRequest)

  return {
    anexarEvidenciaSubContrato,
    create,
    del,
    get,
    getAll,
    getByCnpj,
    getByDescricao,
    getByname,
    getFilterProps,
    patch
  }
}

export interface RequestAnexarEvidenciaSubContrato {
  documentoPaiId?: number
  usuarioId: number
  contratoId: number
  forncedorId: number
  tipoPendenciaId?: number
  tipoDocumentoId?: number
  nuAnoMesCompetencia?: number
  nomeArquivo: string
  descricao: string
  file: string
}

export const SupplierContactsServices = () => {
  const path = 'FornecedorContato'
  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const patch = async (requestObj: IFornecedor): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  return { create, del, patch }
}

export interface IResponseFiltroFornecedor {
  pageCount: number
  totalItemCount: number
  pageNumber: number
  pageSize: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  isFirstPage: boolean
  isLastPage: boolean
  firstItemOnPage: number
  lastItemOnPage: number
  items: any[]
}
export interface IFornecedor {
  idFornecedor: number
  cdFornecedor: string
  cdFornecedorSap: string
  cdTipoFornecedor: string
  cdDocto: string
  nmFornecedor: string
  cdCep: string
  txEndereco: string
  nuNumero: string
  txComplemento: string
  txBairro: string
  sgPais: string
  sgEstado: string
  txCidade: string
  nuTelefone: string
  nuCelular: string
  nmResponsavel: string
  cdCpfResponsavel: string
  txEmailResponsavel: string
  nuCelResponsavel: string
  flSap: boolean
  dtPrimeiroAcesso: string
  contactBusiness0?: string
  contactBusiness1?: string
  tFornecedorContatos?: IFornecedorContatos[]
  contatosComercial?: IFornecedorContatos[]
  contatosTrabalhista?: IFornecedorContatos[]
  contatosSeguranca?: IFornecedorContatos[]
  contatosImportacao?: IFornecedorContatos[]
}

export interface IFornecedorContatos {
  idFornecedorContato?: number
  fornecedorId?: number
  nmContato?: string
  txEmail?: string
  cdTipo?: string
}

interface IGetFilterProps {
  CdFornecedor?: number
  CdFornecedorSap?: string
  CdTipoFornecedor?: string
  CdDocto?: string
  NmFornecedor?: string
  PageNumber?: number
  PageSize?: number
}
